import { useSelector } from 'react-redux';
import { ncFileStatuses, machineStatus as machineStatuses } from '@helpers';
import { selectSingleBatchData } from '@reducers/batch';

interface Props {
  isOperator?: boolean;
  ncFileStatus: (typeof ncFileStatuses)[keyof typeof ncFileStatuses];
  machineStatus: string;
}

export const useOperatorPanelStatuses = ({ machineStatus, ncFileStatus, isOperator = true }: Props) => {
  const ncFileChange = ncFileStatus === ncFileStatuses.Change;
  const ncFileUnknown = ncFileStatus === ncFileStatuses.Unknown;
  const ncFileLinked = ncFileStatus === ncFileStatuses.Linked;
  const ncFileIgnored = ncFileStatus === ncFileStatuses.Ignored;
  const ncFileSetup = ncFileStatus === ncFileStatuses.Setup;

  const batch = useSelector(selectSingleBatchData);

  const machineIsActive = machineStatus === machineStatuses.ACTIVE;
  const machineIsChanged = machineStatus === machineStatuses.CHANGE;
  const machineIsNotProductive = machineStatus === machineStatuses.NOTPRODUCTIVE;

  const batchNotLinked = batch.wasLoaded && batch.data?.links?.length === 0;
  const batchLinked = batch.wasLoaded && batch.data?.links && batch.data?.links?.length > 0;

  return {
    ncFileChange,
    ncFileUnknown,
    ncFileLinked,
    ncFileIgnored,
    ncFileSetup,
    machineIsActive,
    machineIsChanged,
    machineIsNotProductive,
    batchNotLinked,
    batchLinked,
  };
};
